<template>
    <form action="" class="form-horizontal padding-top-30">
        <div class="form-group">
            <label class="col-md-3 control-label" v-text="$lang.get('trans.layout')"></label>
            <div class="col-md-6">
                <select class="form-control" v-model="form.layout">
                    <option value="portrait">Portrait</option>
                    <option value="landscape">Landscape</option>
                </select>
            </div>
        </div>
        <div class="form-group">
            <label class="col-md-3 control-label" v-text="$lang.get('trans.paper_size')"></label>
            <div class="col-md-6">
                <select class="form-control" v-model="form.paperSize">
                    <option value="A4">A4</option>
                    <option value="A3">A3</option>
                    <option value="A2">A2</option>
                    <option value="A1">A1</option>
                    <option value="Letter">Letter</option>
                </select>
            </div>
        </div>
        <div class="form-group">
            <label class="col-md-3 control-label" v-text="$lang.get('trans.margins')"></label>
            <div class="col-md-6">
                <select class="form-control" v-model="form.marginType">
                    <option value="default">Default ({{ defaultMargin }}mm)</option>
                    <option value="none">None</option>
                    <option value="custom">Custom</option>
                </select>

                <div class="row" v-if="customMargins">
                    <div class="col-md-6">
                        <div class="form-group margin-bottom-0">
                            <div class="col-md-12">
                                <label class="control-label text-left">{{ $lang.get('trans.top') }} (mm)</label>
                                <input type="number" class="form-control" min="0" v-model="form.margin.top">
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group margin-bottom-0">
                            <div class="col-md-12">
                                <label class="control-label text-left">{{ $lang.get('trans.bottom') }} (mm)</label>
                                <input type="number" class="form-control" min="0" v-model="form.margin.bottom">
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group margin-bottom-0">
                            <div class="col-md-12">
                                <label class="control-label text-left">{{ $lang.get('trans.left') }} (mm)</label>
                                <input type="number" class="form-control" min="0" v-model="form.margin.left">
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group margin-bottom-0">
                            <div class="col-md-12">
                                <label class="control-label text-left">{{ $lang.get('trans.right') }} (mm)</label>
                                <input type="number" class="form-control" min="0" v-model="form.margin.right">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-group">
            <label class="col-md-3 control-label" v-text="`${$lang.get('trans.scale')} (%)`"></label>
            <div class="col-md-6">
                <input type="number" class="form-control" min="50" max="200" v-model="form.scale">
            </div>
        </div>
        <div class="row">
            <hr>
            <div class="col-md-offset-3 col-md-6">
                <button type="button" class="btn btn-outine dark pull-right" @click.prevent="save">
                    <i class="glyphicon glyphicon-save"></i> Save options
                </button>
            </div>
        </div>
    </form>
</template>

<script>
    export default {
        name: "paper-settings",

        props: {
            options: {
                required: true,
                type: Object
            }
        },

        data() {
            return {
                defaultMargin: 20,
                customMargins: false,
                form: {
                    layout: 'portrait',
                    paperSize: 'A4',
                    scale: 100,
                    marginType: 'default',
                    margin: {
                        top: 20,
                        bottom: 20,
                        left: 20,
                        right: 20
                    }
                },
            }
        },

        watch: {
            options: function (value) {
                if (_.isEmpty(value)) {
                    return
                }

                this.form = value
            },

            'form.marginType': function (value) {
                this.customMargins = false

                if (value === 'none') {
                    this.form.margin.top = 0
                    this.form.margin.bottom = 0
                    this.form.margin.left = 0
                    this.form.margin.right = 0
                }

                if (value === 'default') {
                    this.form.margin.top = this.defaultMargin
                    this.form.margin.bottom = this.defaultMargin
                    this.form.margin.left = this.defaultMargin
                    this.form.margin.right = this.defaultMargin
                }

                if (value === 'custom') {
                    this.customMargins = true
                }
            }
        },

        methods: {
            save() {
                this.$parent.$emit('options-changed', {
                    options: this.form
                })
            }
        },

        mounted() {
            _.merge(this.form, this.options)

            this.$parent.$emit('options-changed', {
                options: this.form
            })
        }
    }
</script>

<style scoped>

</style>